// extracted by mini-css-extract-plugin
export var defaultWrapper = "_i0-3";
export var downloadButton = "_i0-4";
export var fileContainer = "_i0-9 _i0-7";
export var fileContainerBase = "_i0-7";
export var fileContainerFixedHeight = "_i0-8 _i0-7";
export var fileInfo = "_i0-5";
export var fileInfoWidthRestricted = "_i0-6";
export var fileType = "_i0-1";
export var fileTypeName = "_i0-2";
export var image = "_i0-0";
export var link = "_i0-b";
export var overflowEllipsis = "_i0-a";